/**
 * Schema for the ordered item price option as it appears in requests.
 * Note that this schema differs from the database schema.
 */
export const orderedPriceOptionSchema = {
    displayName: 'ordered price option',
    type: 'object',
    fields: {
        _id: {
            type: 'mongoId',
            required: true,
            isPermanent: true,
        },
        quantity: {
            type: 'int',
            min: 1,
            required: true,
            isPermanent: true,
        },
        weight: {
            type: 'float',
            min: 0,
            isPermanent: true,
        },
        // TODO: remove this field; currently needed for backwards compatibility with old GCN versions
        addonSets: {
            type: 'array',
            elementType: 'object',
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                    isPermanent: true,
                },
                parentModGroupId: {
                    type: 'mongoId',
                },
                originalId: {
                    type: 'mongoId',
                },
                items: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        _id: {
                            type: 'mongoId',
                            required: true,
                            isPermanent: true,
                        },
                        priceOption: {
                            type: 'object',
                            subtype: 'OrderedPriceOption',
                            required: true,
                        },
                        upsellScreen: {
                            type: 'shortString',
                        },
                        substitutionFor: {
                            type: 'object',
                            fields: {
                                modId: {
                                    type: 'mongoId',
                                },
                                substitutionModGroupId: {
                                    type: 'mongoId',
                                },
                            },
                        },
                    },
                },
            },
        },
        modGroups: {
            type: 'array',
            elementType: 'object',
            fields: {
                _id: {
                    type: 'mongoId',
                    required: true,
                    isPermanent: true,
                },
                parentModGroupId: {
                    type: 'mongoId',
                },
                originalId: {
                    type: 'mongoId',
                },
                items: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        _id: {
                            type: 'mongoId',
                            required: true,
                            isPermanent: true,
                        },
                        priceOption: {
                            type: 'object',
                            subtype: 'OrderedPriceOption',
                            required: true,
                        },
                        upsellScreen: {
                            type: 'shortString',
                        },
                        substitutionFor: {
                            type: 'object',
                            fields: {
                                modId: {
                                    type: 'mongoId',
                                },
                                substitutionModGroupId: {
                                    type: 'mongoId',
                                },
                            },
                        },
                    },
                },
                deselectedItems: {
                    type: 'array',
                    elementType: 'object',
                    fields: {
                        _id: {
                            type: 'mongoId',
                            required: true,
                            isPermanent: true,
                        },
                        priceOption: {
                            type: 'object',
                            subtype: 'OrderedPriceOption',
                            required: true,
                        },
                    },
                },
            },
        },
    },
};
//# sourceMappingURL=ordered_price_option_schema.js.map